import mixins from 'vue-typed-mixins';
import { ReportNode, QuestionData, ReportContext } from '@/utils/ReportUtils';
import { Question } from '@/utils/SurveyUtils';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },
  },
});
